import React from "react";
import "./App.css";
import { LoadingIndicator } from "@sunrun/experience-ui-components";
import { SupportPage } from "./components/pages/SupportPage";
import { useUserProfile } from "./providers/UserProfile";
import { ChannelPartnerSupportPage } from "./components/pages/ChannelPartnerSupportPage";
import { PlaybookPage } from "./components/pages/PlaybookPage";

function App() {
  const userProfile = useUserProfile();
  if (!userProfile) return <LoadingIndicator color="black" fullScreen />;

  if (window.location.pathname.startsWith("/playbook")) {
    return <PlaybookPage />;
  }

  return (
    <div className="App">
      {userProfile.splatRole === "Integrated Partner" ? (
        <ChannelPartnerSupportPage />
      ) : (
        <SupportPage />
      )}
    </div>
  );
}
export { App };
